module.exports = __webpack_public_path__ + "img/home.c46d304a.svg";